import { render } from "./PdfLayout.vue?vue&type=template&id=bd3bbf2e&scoped=true"
import script from "./PdfLayout.vue?vue&type=script&lang=js"
export * from "./PdfLayout.vue?vue&type=script&lang=js"

import "./PdfLayout.vue?vue&type=style&index=0&id=bd3bbf2e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3bbf2e"]])

export default __exports__